// removed by extract-text-webpack-plugin
module.exports = {"tabs":"_3ljvB","tab":"_29ikZ","openTab":"_2VLXy _29ikZ","fullWidthTab":"_2p3bZ _29ikZ","bubble":"_3TK8x","bubbleButton":"_1KJXP _3TK8x","panel":"hnga5","flex":"_3oc2q","scheduleInput":"_1LGDV"};


//////////////////
// WEBPACK FOOTER
// ./src/components/channels/ChannelTabs.css
// module id = 818
// module chunks = 0